<div *ngIf="order; else indicateLoading" class="receipt p-card">
  <div class="provider-details">
    <div class="user-order-details">
      <div>
        <strong translate>order-receipt.heading-order</strong>
        {{ order.id }}
      </div>
      <div>
        <strong translate>order-receipt.heading-placed</strong>
        <vnm-date [date]="order.createdAt"></vnm-date>
      </div>
      <div>
        <strong translate>order-receipt.heading-payment</strong>
        {{ order.totalFormatted }}
      </div>
      <div class="user-address">
        <strong translate>order-receipt.heading-paid-by</strong>
        <div>
          <div class="user-address-name">
            <div>{{ order.user.fullName }}</div>
            <div *ngIf="order?.user?.certificationDefault">{{ order.user.certificationDefault.name }}</div>
          </div>
          <vnm-address
            *ngIf="billingAddressIsComplete; else billingRegion"
            [address]="order.billingAddress"
          ></vnm-address>
          <ng-template #billingRegion>
            <span>{{ order.billingAddress.province }}</span
            ><span>,</span>
            <span>{{ order.billingAddress.country }}</span>
          </ng-template>
        </div>
      </div>
      <div *ngIf="hasAnyShippingInformation">
        <strong translate>order-receipt.heading-shipped-to</strong>
        <vnm-shipping-information
          *ngIf="order.shippingInformation"
          [shippingInformation]="order.shippingInformation"
        ></vnm-shipping-information>
        <vnm-address *ngIf="order.shippingAddress" [address]="order.shippingAddress"></vnm-address>
      </div>
    </div>
    <div *ngIf="order?.storefront?.address" class="storefront-address">
      <h3>{{ order.storefront.name }}</h3>
      <div
        *ngIf="order?.storefront?.businessNumber"
        [innerHTML]="'order-receipt.business-number' | translate: { number: order?.storefront?.businessNumber }"
      ></div>
      <vnm-address [address]="order.storefront.address"></vnm-address>
      <br />
      <vnm-phone-number [number]="order?.storefront?.phoneNumber"></vnm-phone-number>
      <vnm-email-address [email]="order?.storefront?.email"></vnm-email-address>
    </div>
  </div>
  <table class="receipt-order-items">
    <thead>
      <tr>
        <th translate>order-receipt.item</th>
        <th translate>order-receipt.price</th>
        <th translate>order-receipt.qty</th>
        <th translate>order-receipt.total</th>
      </tr>
    </thead>
    <tbody>
      <vnm-order-receipt-item
        *ngFor="let orderItem of order.orderItems"
        [orderItem]="orderItem"
        [promoCodeUse]="promoCodeUseOn(orderItem)"
      ></vnm-order-receipt-item>
      <tr>
        <td colspan="3" translate>order-receipt.shipping</td>
        <td>{{ order.shippingFormatted }}</td>
      </tr>
      <tr>
        <td colspan="3" translate>order-receipt.subtotal</td>
        <td>{{ order.subtotalFormatted }}</td>
      </tr>
      <tr *ngFor="let taxItem of order.taxItems">
        <td colspan="3">{{ taxItem.description }}</td>
        <td>{{ taxItem.amountFormatted }}</td>
      </tr>
      <tr>
        <td colspan="3" translate>order-receipt.total</td>
        <td>{{ order.totalFormatted }}</td>
      </tr>
      <ng-container *ngIf="order.refundedAmount > 0">
        <tr>
          <td colspan="3" translate>order-receipt.refunded-amount</td>
          <td>
            {{ order.refundedAmountFormatted }}
          </td>
        </tr>
        <tr>
          <td colspan="3" translate>order-receipt.adjusted-total</td>
          <td>{{ order.refundableAmountFormatted }}</td>
        </tr>
      </ng-container>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="4" [innerHTML]="'order-receipt.payment-method' | translate: { method: order.paymentMethod }"></td>
      </tr>
    </tfoot>
  </table>
</div>
<ng-template #indicateLoading>
  <div class="receipt p-card">
    <div class="p-card-header flex justify-content-between">
      <vnm-skeleton-rect height="150px" width="250px"></vnm-skeleton-rect>
      <vnm-skeleton-rect height="180px" width="250px"></vnm-skeleton-rect>
    </div>
    <div class="p-card-body">
      <div class="p-card-content flex flex-column align-items-end">
        <vnm-skeleton-rect height="45px" width="100%"></vnm-skeleton-rect>
        <vnm-skeleton-rect height="25px" width="50%"></vnm-skeleton-rect>
        <vnm-skeleton-rect height="25px" width="50%"></vnm-skeleton-rect>
        <vnm-skeleton-rect height="25px" width="50%"></vnm-skeleton-rect>
        <vnm-skeleton-rect height="25px" width="50%"></vnm-skeleton-rect>
      </div>
    </div>
  </div>
</ng-template>
